import { codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import '../client/temp-common-imports';

export class ErrorController implements Controller {
  public pageId = '500';
  public path = '/error';
  public routeName = 'error';
  public exact = true;
  public bundles = [];

  public component = codeSplit(() => import(/* webpackChunkName: "error-page" */ '../views/error-page'));

  public fetch(options: FetchOptions) {
    return Promise.resolve(Result.ok());
  }

  public fetchPageData() {
    return Promise.resolve({ title: "Something's not right" });
  }
}
